import { PayloadAction } from '@reduxjs/toolkit';
import { State } from './reducer';
import { IRisk } from '../../../../models/Dictionaries';

export const setDictRisksOc = (
	state: State,
	action: PayloadAction<IRisk[]>
) => {
	state.risksOc = action.payload;
};

export const setDictRisksKop = (
	state: State,
	action: PayloadAction<IRisk[]>
) => {
	state.risksKop = action.payload;
};

export const setDictRisksNnw = (
	state: State,
	action: PayloadAction<IRisk[]>
) => {
	state.risksNnw = action.payload;
};

export const setDictRisksNnwKlauzule = (
	state: State,
	action: PayloadAction<IRisk[]>
) => {
	state.risksNnwKlauzule = action.payload;
};

export const setLoaded = (state: State, action: PayloadAction<boolean>) => {
	state.loaded = action.payload;
};
